import React from 'react';

const Stockadjustmentinsert = () => {
  return <div>Stockadjustmentinsert</div>;
};

export default Stockadjustmentinsert;
